<template>
  <CadastroBase
    nomePlural="FuncionarioPontos"
    nomeSingular="FuncionarioPonto"
    @submitSuccessInsert="emitSubmitSuccess"
    @submitErrorInsert="emitSubmitError"
    @closeModalInsert="closeModal"
  >
    <v-col cols="12">
      <v-row>
        <v-col cols="12" md="6">
          <CampoDataHora
            :payload="recurso.data"
            :label="$t('Data_e_hora')"
            @date="recurso.data = $event"
          />
        </v-col>

        <v-col cols="12" md="6">
          <v-autocomplete
            v-model="recurso.matricula"
            :items="todosFuncionarios"
            item-text="pessoa.nome"
            item-value="matricula"
            :label="$t('Funcionario')"
            class="
              input-style
              font-size-input
              text-light-input
              placeholder-light
              input-icon
            "
            dense
            flat
            filled
            solo
          />
        </v-col>

        <v-col cols="12" v-if="!registroPontoTravarJustificativa">
          <v-text-field
            v-model="recurso.justificativa"
            :label="$t('Justificativa')"
            name="Justificativa"
            class="
              input-style
              font-size-input
              text-light-input
              placeholder-light
              input-icon
            "
            dense
            flat
            filled
            solo
          />
        </v-col>

        <v-col cols="12" v-if="registroPontoTravarJustificativa">
          <v-select
            v-model="recurso.justificativa"
            :items="splitItemsRegistroPontoJustificativa"
            :label="$t('Justificativa')"
            class="
              input-style
              font-size-input
              text-light-input
              placeholder-light
              input-icon
            "
            dense
            flat
            filled
            solo
          />
        </v-col>
      </v-row>
    </v-col>
  </CadastroBase>
</template>

<script>
import DataService from "@/services/pessoal/FuncionarioPontoDataService";

import CadastroBase from "@/components/base/Crud/CadastroBase";

export default {
  name: "CadastroFuncionarioPonto",
  components: { CadastroBase },

  data() {
    return {
      DataService: DataService,

      recurso: {
        data: "",
        justificativa: "",
        //imagem: "",

        matricula: "",
      },
      todosFuncionarios: [],

      registroPontoTravarJustificativa: false,
      splitItemsRegistroPontoJustificativa: [],
    };
  },

  mounted() {
    this.getFuncionarios();
    this.registroPontoVerificarTravaJustificativa();
  },

  methods: {
    emitSubmitSuccess() {
      this.$emit("submitSuccessInsert");
    },
    emitSubmitError() {
      this.$emit("submitErrorInsert");
    },
    closeModal() {
      this.$emit("closeModalInsert");
    },
    getFuncionarios() {
      DataService.getFuncionarios()
        .then((response) => {
          console.log(response.data);
          this.todosFuncionarios = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    registroPontoVerificarTravaJustificativa() {
      console.log("registroPontoVerificarTravaJustificativa");
      var parametrizacaoExistente =
        this.$store.state.inquilino.parametrizacoes.find(
          (item) => item.tipo == "RESTRINGIRJUSTIFICATIVAREGISTROPONTO"
        );

      if (parametrizacaoExistente) {
        this.registroPontoTravarJustificativa = parametrizacaoExistente.ativo;

        this.splitItemsRegistroPontoJustificativa =
          parametrizacaoExistente.texto
            .split(";")
            .filter((item) => item.trim() !== ""); // Separa a string pelo ';' e remove itens vazios

        console.log(
          "  this.splitItemsRegistroPontoJustificativa",
          this.splitItemsRegistroPontoJustificativa
        );
      }
    },
  },
};
</script>

<style scoped></style>
